export default __webpack_public_path__ + "image/bg-share-daa3c007.png";